/* LARGO — micro-mouvement.
 * Règle de sûreté : un élément n'est jamais masqué sans garantie d'être révélé.
 * - désactivé dans l'éditeur de thème (Shopify.designMode)
 * - révélation immédiate si l'élément est déjà visible
 * - filet de sécurité : tout est révélé après 2,5 s quoi qu'il arrive
 */
(function () {
  var doc = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);

  /* Dans l'éditeur, en mouvement réduit ou sans IntersectionObserver :
     on ne masque rien du tout. Les sections s'affichent normalement. */
  if (design || reduce || !('IntersectionObserver' in window)) return;

  var TEXT = [
    '.lg-sechead h2', '.lg-sechead .lg-lnk', '.lg-card', '.lg-split__tx > *',
    '.lg-spec__row', '.lg-quote blockquote', '.lg-quote .lg-kicker', '.lg-word',
    '.lg-serv__i', '.lg-pagehead > *', '.lg-testi__head > *', '.lg-wall__tick',
    '.lg-contact__tx > *', '.lg-sil__cap'
  ].join(',');

  var MEDIA = [
    '.lg-sil__im', '.lg-split__im', '.lg-wall figure', '.lg-contact__im'
  ].join(',');

  var SECTIONS = [
  'main .shopify-section'
].join(',');

  var watched = [];
  var timer = null;
  var io = null;

  function reveal(el) {
    if (!el || el.classList.contains('is-in')) return;
    el.classList.add('is-in');
    if (io) { try { io.unobserve(el); } catch (e) {} }
  }

  function stagger(el) {
    var parent = el.parentElement;
    if (!parent) return;
    var sibs = Array.prototype.filter.call(parent.children, function (c) {
      return c.classList.contains('lg-r') || c.classList.contains('lg-img-r');
    });
    var i = sibs.indexOf(el);
    if (i < 1) return;
    el.style.transitionDelay = Math.min(i, 5) * 75 + 'ms';
  }

  /* Visible maintenant ? Inclut le cas des conteneurs à défilement horizontal. */
  function visibleNow(el) {
    var r = el.getBoundingClientRect();
    if (r.width === 0 || r.height === 0) return true; /* pas mesurable : on révèle */
    var vh = window.innerHeight || doc.documentElement.clientHeight;
    var vw = window.innerWidth || doc.documentElement.clientWidth;
    return r.top < vh && r.bottom > 0 && r.left < vw && r.right > 0;
  }

  try {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting || e.intersectionRatio > 0) {
          stagger(e.target);
          reveal(e.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0 });
  } catch (e) {
    io = null;
  }

  function prep(selector, cls) {
    doc.querySelectorAll(selector).forEach(function (el) {
      if (el.dataset.lgDone) return;
      el.dataset.lgDone = '1';

      /* Sans observateur : aucun masquage. */
      if (!io) return;

      el.classList.add(cls);
      watched.push(el);

      if (visibleNow(el)) {
        /* Déjà à l'écran : on joue la transition au frame suivant,
           sans dépendre de l'observateur. */
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { stagger(el); reveal(el); });
        });
        return;
      }

      try { io.observe(el); } catch (err) { reveal(el); }
    });
  }

  /* Filet de sécurité : rien ne peut rester masqué durablement. */
  function failsafe() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      watched.forEach(reveal);
    }, 2500);
  }

  function hero() {
    doc.querySelectorAll('.lg-hero__inner > div > *').forEach(function (el, i) {
      if (el.dataset.lgIn) return;
      el.dataset.lgIn = '1';
      el.classList.add('lg-in');
      el.style.animationDelay = 140 + i * 120 + 'ms';
    });
  }

  function boot() {
prep(TEXT, 'lg-r');
prep(MEDIA, 'lg-img-r');
prep(SECTIONS, 'lg-section-r');
hero();
failsafe();
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', function () { boot(); watched.forEach(function (el) {
    if (visibleNow(el)) reveal(el);
  }); });

  window.addEventListener('pageshow', boot);
  doc.addEventListener('shopify:section:load', boot);
  doc.addEventListener('shopify:section:select', function () { watched.forEach(reveal); });
})();
